function Error() {
  return <h1 className="error">Oops! Page not found!</h1>;
}

export default Error;
